/**
 * @desc some constants for name.ts
 */

export const conjunctionList = ['&', 'and', 'et', 'of', 'the', 'und'];

export const titleList = ['dr', 'miss', 'mr', 'mrs', 'ms', 'prof', 'sir', 'frau', 'herr', 'hr'];

export const forceCaseList = [
  'e',
  'y',
  'av',
  'af',
  'da',
  'dal',
  'de',
  'del',
  'der',
  'di',
  'la',
  'le',
  'van',
  'der',
  'den',
  'vel',
  'von',
  'II',
  'III',
  'IV',
  'J.D.',
  'LL.M.',
  'M.D.',
  'D.O.',
  'D.C.',
  'Ph.D.',
];

export function getSuffixList(useLongLists: number): string[] {
  let suffixList: string[];
  // Initilize lists of prefixs, suffixs, and titles to detect
  // Note: These list entries must be all lowercase
  if (useLongLists) {
    suffixList = [
      'esq',
      'esquire',
      'jr',
      'jnr',
      'sr',
      'snr',
      '2',
      '11',
      'i',
      'ii',
      'iii',
      'iv',
      'v',
      'clu',
      'chfc',
      'cfp',
      'md',
      'phd',
      'j.d.',
      'll.m.',
      'm.d.',
      'd.o.',
      'd.c.',
      'p.c.',
      'ph.d.',
    ];
    // prefixList = ['a','ab','antune','ap','abu','al','alm','alt','bab','bäck',
    //   'bar','bath','bat','beau','beck','ben','berg','bet','bin','bint','birch',
    //   'björk','björn','bjur','da','dahl','dal','de','degli','dele','del',
    //   'della','der','di','dos','du','e','ek','el','escob','esch','fleisch',
    //   'fitz','fors','gott','griff','haj','haug','holm','ibn','kauf','kil',
    //   'koop','kvarn','la','le','lind','lönn','lund','mac','mhic','mic','mir',
    //   'na','naka','neder','nic','ni','nin','nord','norr','ny','o','ua','ui\'',
    //   'öfver','ost','över','öz','papa','pour','quarn','skog','skoog','sten',
    //   'stor','ström','söder','ter','ter','tre','türk','van','väst','väster',
    //   'vest','von'];
    // titleList = ['mr','mrs','ms','miss','dr','herr','monsieur','hr','frau',
    //   'a v m','admiraal','admiral','air cdre','air commodore','air marshal',
    //   'air vice marshal','alderman','alhaji','ambassador','baron','barones',
    //   'brig','brig gen','brig general','brigadier','brigadier general',
    //   'brother','canon','capt','captain','cardinal','cdr','chief','cik','cmdr',
    //   'coach','col','col dr','colonel','commandant','commander','commissioner',
    //   'commodore','comte','comtessa','congressman','conseiller','consul',
    //   'conte','contessa','corporal','councillor','count','countess',
    //   'crown prince','crown princess','dame','datin','dato','datuk',
    //   'datuk seri','deacon','deaconess','dean','dhr','dipl ing','doctor',
    //   'dott','dott sa','dr','dr ing','dra','drs','embajador','embajadora','en',
    //   'encik','eng','eur ing','exma sra','exmo sr','f o','father',
    //   'first lieutient','first officer','flt lieut','flying officer','fr',
    //   'frau','fraulein','fru','gen','generaal','general','governor','graaf',
    //   'gravin','group captain','grp capt','h e dr','h h','h m','h r h','hajah',
    //   'haji','hajim','her highness','her majesty','herr','high chief',
    //   'his highness','his holiness','his majesty','hon','hr','hra','ing','ir',
    //   'jonkheer','judge','justice','khun ying','kolonel','lady','lcda','lic',
    //   'lieut','lieut cdr','lieut col','lieut gen','lord','m','m l','m r',
    //   'madame','mademoiselle','maj gen','major','master','mevrouw','miss',
    //   'mlle','mme','monsieur','monsignor','mr','mrs','ms','mstr','nti','pastor',
    //   'president','prince','princess','princesse','prinses','prof','prof dr',
    //   'prof sir','professor','puan','puan sri','rabbi','rear admiral','rev',
    //   'rev canon','rev dr','rev mother','reverend','rva','senator','sergeant',
    //   'sheikh','sheikha','sig','sig na','sig ra','sir','sister','sqn ldr','sr',
    //   'sr d','sra','srta','sultan','tan sri','tan sri dato','tengku','teuku',
    //   'than puying','the hon dr','the hon justice','the hon miss','the hon mr',
    //   'the hon mrs','the hon ms','the hon sir','the very rev','toh puan','tun',
    //   'vice admiral','viscount','viscountess','wg cdr', 'ind', 'misc', 'mx'];
  } else {
    suffixList = [
      'esq',
      'esquire',
      'jr',
      'jnr',
      'sr',
      'snr',
      '2',
      '11',
      'i',
      'ii',
      'iii',
      'iv',
      'md',
      'phd',
      'j.d.',
      'll.m.',
      'm.d.',
      'd.o.',
      'd.c.',
      'p.c.',
      'ph.d.',
    ];
    // prefixList = ['ab','bar','bin','da','dal','de','de la','del','della','der',
    //   'di','du','ibn','l\'','la','le','san','st','st.','ste','ter','van',
    //   'van de','van der','van den','vel','ver','vere','von'];
    // titleList = ['dr','miss','mr','mrs','ms','prof','sir','frau','herr','hr',
    //   'monsieur','captain','doctor','judge','officer','professor', 'ind', 'misc',
    //   'mx'];
  }
  return suffixList;
}
